<app-loader *ngIf="isLoading" ></app-loader>

<router-outlet />